import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    FlowEdge,
    SettingOption,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';

export default class Tibbit_00_1 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_00_1';
        this.name = 'Tibbit 00_1';
        const settings = [
            {
                id: 'GENERAL',
                name: 'General',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'LN1',
                name: 'I/O 1',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'LN2',
                name: 'I/O 2',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'LN3',
                name: 'I/O 3',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'LN4',
                name: 'I/O 4',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'MODE',
                name: 'Peripheral Mode',
                settingType: SettingType.OPTION,
                default: 'IO',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'IO',
                        value: 'IO',
                    },
                    {
                        name: 'Serial',
                        value: 'SERIAL',
                    },
                    {
                        name: 'I2C',
                        value: 'I2C',
                    },
                    {
                        name: 'SPI',
                        value: 'SPI',
                    },
                ],
            },
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                default: '',
                group: 'GENERAL',
                required: true,
            },
            {
                id: 'BAUD',
                name: 'Baud Rate',
                settingType: SettingType.OPTION,
                required: true,
                default: '9600',
                linkToSetting: true,
                options: [
                    {
                        name: '1200',
                        value: '1200',
                    },
                    {
                        name: '2400',
                        value: '2400',
                    },
                    {
                        name: '4800',
                        value: '4800',
                    },
                    {
                        name: '9600',
                        value: '9600',
                    },
                    {
                        name: '19200',
                        value: '19200',
                    },
                    {
                        name: '38400',
                        value: '38400',
                    },
                    {
                        name: '57600',
                        value: '57600',
                    },
                    {
                        name: '115200',
                        value: '115200',
                    },
                    {
                        name: '230400',
                        value: '230400',
                    },
                    {
                        name: '460800',
                        value: '460800',
                    },
                    {
                        name: '921600',
                        value: '921600',
                    },
                ],
                setting: {
                    SETTINGID: 'T05BAUD',
                    NAME: 'Tibbit 05 Baud Rate',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 0,
                    MAX: 8,
                    DEFAULT: '9600',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: '1200',
                            value: '1200',
                        },
                        {
                            name: '2400',
                            value: '2400',
                        },
                        {
                            name: '4800',
                            value: '4800',
                        },
                        {
                            name: '9600',
                            value: '9600',
                        },
                        {
                            name: '19200',
                            value: '19200',
                        },
                        {
                            name: '38400',
                            value: '38400',
                        },
                        {
                            name: '57600',
                            value: '57600',
                        },
                        {
                            name: '115200',
                            value: '115200',
                        },
                        {
                            name: '230400',
                            value: '230400',
                        },
                        {
                            name: '460800',
                            value: '460800',
                        },
                        {
                            name: '921600',
                            value: '921600',
                        },
                    ],
                },
            },
            {
                id: 'FLOWCONTROL',
                name: 'Flow Control',
                settingType: SettingType.OPTION,
                required: true,
                default: 'PL_SER_FC_DISABLED',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'RTSCTS',
                        value: '1',
                    },
                    {
                        name: 'XONOFF',
                        value: '2',
                    },
                ],
            },
            {
                id: 'PARITY',
                name: 'Parity',
                settingType: SettingType.OPTION,
                required: true,
                linkToSetting: true,
                default: '0',
                options: [
                    {
                        name: 'None',
                        value: '0',
                    },
                    {
                        name: 'Even',
                        value: '1',
                    },
                    {
                        name: 'Odd',
                        value: '2',
                    },
                    {
                        name: 'Mark (Always 1)',
                        value: '3',
                    },
                    {
                        name: 'Space (Always 0)',
                        value: '4',
                    },
                ],
                setting: {
                    SETTINGID: 'PARITY',
                    NAME: 'Tibbit 05 Parity',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'None',
                            value: '0',
                        },
                        {
                            name: 'Even',
                            value: '1',
                        },
                        {
                            name: 'Odd',
                            value: '2',
                        },
                        {
                            name: 'Mark(Always 1)',
                            value: '3',
                        },
                        {
                            name: 'Space(Always 0)',
                            value: '4',
                        },
                    ],
                },
            },
            {
                id: 'BITS',
                name: 'Data Bits',
                settingType: SettingType.OPTION,
                required: true,
                linkToSetting: true,
                default: '1',
                options: [
                    {
                        name: '7 Bits',
                        value: '0',
                    },
                    {
                        name: '8 Bits',
                        value: '1',
                    },
                ],
                setting: {
                    SETTINGID: 'BITS',
                    NAME: 'Tibbit 05 Data Bits',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '1',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: '7 Bits',
                            value: '0',
                        },
                        {
                            name: '8 Bits',
                            value: '1',
                        },
                    ],
                },
            },
            {
                id: 'L1NAME',
                name: 'LN1 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                default: '',
                group: 'LN1',
                required: true,
            },
            {
                id: 'L1DIRECTION',
                name: 'LN1 Direction',
                settingType: SettingType.OPTION,
                default: '1',
                group: 'LN1',
                required: true,
                options: [
                    {
                        name: 'Input',
                        value: '1',
                    },
                    {
                        name: 'Output',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L1STATE',
                name: 'LN1 Initial State',
                settingType: SettingType.HIDDEN,
                default: '0',
                group: 'LN1',
                required: true,
                options: [
                    {
                        name: 'High',
                        value: '1',
                    },
                    {
                        name: 'Low',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L2NAME',
                name: 'LN2 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                default: '',
                group: 'LN2',
                required: true,
            },
            {
                id: 'L2DIRECTION',
                name: 'LN2 Direction',
                settingType: SettingType.OPTION,
                default: '1',
                group: 'LN2',
                required: true,
                options: [
                    {
                        name: 'Input',
                        value: '1',
                    },
                    {
                        name: 'Output',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L2STATE',
                name: 'LN2 Initial State',
                settingType: SettingType.HIDDEN,
                default: '0',
                group: 'LN2',
                required: true,
                options: [
                    {
                        name: 'High',
                        value: '1',
                    },
                    {
                        name: 'Low',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L3NAME',
                name: 'LN3 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                default: '',
                group: 'LN3',
                required: true,
            },
            {
                id: 'L3DIRECTION',
                name: 'LN3 Direction',
                settingType: SettingType.OPTION,
                default: '1',
                group: 'LN3',
                required: true,
                options: [
                    {
                        name: 'Input',
                        value: '1',
                    },
                    {
                        name: 'Output',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L3STATE',
                name: 'LN3 Initial State',
                settingType: SettingType.HIDDEN,
                default: '0',
                group: 'LN3',
                required: true,
                options: [
                    {
                        name: 'High',
                        value: '1',
                    },
                    {
                        name: 'Low',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L4NAME',
                name: 'LN4 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                default: '',
                group: 'LN4',
                required: true,
            },
            {
                id: 'L4DIRECTION',
                name: 'LN4 Direction',
                settingType: SettingType.OPTION,
                default: '1',
                group: 'LN4',
                required: true,
                options: [
                    {
                        name: 'Input',
                        value: '1',
                    },
                    {
                        name: 'Output',
                        value: '0',
                    },
                ],
            },
            {
                id: 'L4STATE',
                name: 'LN4 Initial State',
                settingType: SettingType.HIDDEN,
                default: '0',
                group: 'LN4',
                required: true,
                options: [
                    {
                        name: 'High',
                        value: '1',
                    },
                    {
                        name: 'Low',
                        value: '0',
                    },
                ],
            },
            {
                id: 'INTENABLED',
                name: 'Interrupt',
                settingType: SettingType.OPTION,
                default: '0',
                group: 'LN4',
                required: true,
                options: [
                    {
                        name: 'Yes',
                        value: '1',
                    },
                    {
                        name: 'No',
                        value: '0',
                    },
                ],
            },
            {
                id: 'I2CSDA',
                name: 'SDA Line',
                settingType: SettingType.OPTION,
                default: '0',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'Line 1',
                        value: '0',
                    },
                    {
                        name: 'Line 2',
                        value: '1',
                    },
                    {
                        name: 'Line 3',
                        value: '2',
                    },
                    {
                        name: 'Line 4',
                        value: '3',
                    },
                ],
            },
            {
                id: 'I2CSCL',
                name: 'SCL Line',
                settingType: SettingType.OPTION,
                default: '1',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'Line 1',
                        value: '0',
                    },
                    {
                        name: 'Line 2',
                        value: '1',
                    },
                    {
                        name: 'Line 3',
                        value: '2',
                    },
                    {
                        name: 'Line 4',
                        value: '3',
                    },
                ],
            },
            {
                id: 'SPICLK',
                name: 'CLK Line',
                settingType: SettingType.OPTION,
                default: '0',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'Line 1',
                        value: '0',
                    },
                    {
                        name: 'Line 2',
                        value: '1',
                    },
                    {
                        name: 'Line 3',
                        value: '2',
                    },
                    {
                        name: 'Line 4',
                        value: '3',
                    },
                ],
            },
            {
                id: 'SPIDI',
                name: 'DI Line',
                settingType: SettingType.OPTION,
                default: '1',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'Line 1',
                        value: '0',
                    },
                    {
                        name: 'Line 2',
                        value: '1',
                    },
                    {
                        name: 'Line 3',
                        value: '2',
                    },
                    {
                        name: 'Line 4',
                        value: '3',
                    },
                ],
            },
            {
                id: 'SPIDO',
                name: 'DO Line',
                settingType: SettingType.OPTION,
                default: '2',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'Line 1',
                        value: '0',
                    },
                    {
                        name: 'Line 2',
                        value: '1',
                    },
                    {
                        name: 'Line 3',
                        value: '2',
                    },
                    {
                        name: 'Line 4',
                        value: '3',
                    },
                ],
            },
            {
                id: 'SPICS',
                name: 'CS Line',
                settingType: SettingType.OPTION,
                default: '3',
                group: 'GENERAL',
                required: true,
                options: [
                    {
                        name: 'Line 1',
                        value: '0',
                    },
                    {
                        name: 'Line 2',
                        value: '1',
                    },
                    {
                        name: 'Line 3',
                        value: '2',
                    },
                    {
                        name: 'Line 4',
                        value: '3',
                    },
                ],
            },
            {
                id: 'CLOCKMODE',
                name: 'Clock Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'GENERAL',
                default: '0',
                options: [
                    {
                        name: 'Mode 0: CPOL=0, CPHA=0',
                        value: '0',
                    },
                    {
                        name: 'Mode 1: CPOL=0, CPHA=1',
                        value: '1',
                    },
                    {
                        name: 'Mode 2: CPOL=1, CPHA=0',
                        value: '2',
                    },
                    {
                        name: 'Mode 3: CPOL=1, CPHA=1',
                        value: '3',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'INTENABLED') {
            const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
            if (!interruptNumber) {
                return super.getSettingOptions(settingId);
            }
            const intEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
            if (!intEnum) {
                return [
                    {
                        name: 'No',
                        value: '0',
                    },
                ];
            }
        }
        return super.getSettingOptions(settingId);
    }

    getState(settingId: string): SettingState {
        const MODE = this.getSettingValue('MODE');
        const ioSettings = ['L1NAME', 'L1STATE', 'L1DIRECTION', 'L2NAME', 'L2STATE', 'L2DIRECTION', 'L3NAME', 'L3STATE', 'L3DIRECTION', 'L4NAME', 'L4STATE', 'L4DIRECTION', 'INTENABLED'];
        const serSettings = ['TX', 'RX', 'RTS', 'CTS', 'BAUD', 'FLOWCONTROL', 'PARITY', 'BITS'];
        const i2cSettings = ['I2CSDA', 'I2CSCL'];
        const spiSettings = ['SPICLK', 'SPIDI', 'SPIDO', 'SPICS', 'CLOCKMODE'];

        if (settingId === 'MODE') {
            return SettingState.ENABLED;
        }

        if (settingId === 'INTENABLED' && MODE === 'IO') {
            const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
            if ((this.getSettingValue('L4DIRECTION') === '0') || (interruptNumber === undefined)) {
                return SettingState.DISABLED;
            }
        }

        for (let i = 1; i <= 4; i += 1) {
            if (settingId === `L${i}STATE`) {
                if ((this.getSettingValue(`L${i}DIRECTION`) === '1')) {
                    return SettingState.DISABLED;
                }
            }
        }

        switch (MODE) {
            case 'IO':
                if (serSettings.includes(settingId)
                    || i2cSettings.includes(settingId)
                    || spiSettings.includes(settingId)) {
                    return SettingState.HIDDEN;
                }
                return SettingState.ENABLED;
            case 'SERIAL':
                if (ioSettings.includes(settingId)
                    || i2cSettings.includes(settingId)
                    || spiSettings.includes(settingId)) {
                    return SettingState.HIDDEN;
                }
                break;
            case 'I2C':
                if (ioSettings.includes(settingId)
                    || serSettings.includes(settingId)
                    || spiSettings.includes(settingId)) {
                    return SettingState.HIDDEN;
                }
                break;
            case 'SPI':
                if (ioSettings.includes(settingId)
                    || i2cSettings.includes(settingId)
                    || serSettings.includes(settingId)) {
                    return SettingState.HIDDEN;
                }
                break;
            default:
                return SettingState.ENABLED;
        }
        return SettingState.ENABLED;
    }

    getFiles(): Array<string> {
        let { files } = this;
        if (this.getSettingValue('MODE') === 'I2C') {
            files = files.concat([
                'libraries/super_i2c/super_i2c.tbh',
                'libraries/super_i2c/super_i2c.tbs',
                'libraries/ssi/ssi.tbh',
                'libraries/ssi/ssi.tbs',
            ]);
        }
        if (this.getSettingValue('MODE') === 'SPI') {
            files = files.concat([
                'libraries/super_spi/super_spi.tbh',
                'libraries/super_spi/super_spi.tbs',
                'libraries/ssi/ssi.tbh',
                'libraries/ssi/ssi.tbs',
            ]);
        }

        return files;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        if (this.getSettingValue('MODE') === 'IO') {
            if (this.getSettingValue('L1NAME').trim() === '') {
                errors.push({ message: 'Please enter value for LN1 Name', messageType: ValidationMessageType.ERROR });
            }
            if (this.getSettingValue('L2NAME').trim() === '') {
                errors.push({ message: 'Please enter value for LN2 Name', messageType: ValidationMessageType.ERROR });
            }
            if (this.getSettingValue('L3NAME').trim() === '') {
                errors.push({ message: 'Please enter value for LN3 Name', messageType: ValidationMessageType.ERROR });
            }
            if (this.getSettingValue('L4NAME').trim() === '') {
                errors.push({ message: 'Please enter value for LN4 Name', messageType: ValidationMessageType.ERROR });
            }
        }
        return errors;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        const tibbitName = `TBT00_1S${this.getSettingValue('SOCKET')}`;
        const project: ProjectConfiguration = this.project;
        const ID = this.getID();
        const NAME = this.getSettingValue('NAME');


        switch (this.getSettingValue('MODE')) {
            case 'SERIAL': {
                const FLOWCONTROL = this.getSettingValue('FLOWCONTROL');
                let flowControlMap = '';
                if (FLOWCONTROL === '1') { // RTSCTS
                    const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
                    if (!interruptNumber) {
                        break;
                    }
                    const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
                    flowControlMap = `
    ser.rtsmap=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.enabled=YES
    ser.ctsmap=${interruptEnum}
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[3]}
    io.enabled=NO`;
                }
                blocks.push({
                    location: 'boot',
                    blockType: BlockType.CODE,
                    template: `
    Tibbit 00_1 setup on socket ${this.getSettingValue('SOCKET')} for Serial
    ${NAME}=${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}
    ser.num=S${this.getSettingValue('SOCKET')}_TBT00_1
    ${flowControlMap}
    ser.parity=${this.project.convertDataType(this.getSettingValue('PARITY'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.bits=${this.project.convertDataType(this.getSettingValue('BITS'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.flowcontrol=${this.project.convertDataType(this.getSettingValue('FLOWCONTROL'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.baudrate=ser.div9600*9600/${this.project.convertDataType(this.getSettingValue('BAUD'), TibboDataType.STRING, TibboDataType.WORD)}
    ser.interface=PL_SER_SI_FULLDUPLEX
    ser.esctype=PL_SER_ET_DISABLED
    ser.interchardelay=0
    ser.txbuffrq(1)
    ser.rxbuffrq(1)
    sys.buffalloc()
    
    ser.enabled=YES`,
                });

                blocks.push({
                    location: 'on_ser_data_arrival',
                    blockType: BlockType.CODE,
                    template: `
    if ser.num=S${this.getSettingValue('SOCKET')}_TBT00_1 then
        'data on serial port S${this.getSettingValue('SOCKET')}_TBT00_1
    end if
                `,
                });

                blocks.push({
                    location: 'GLOBAL_CONSTS',
                    blockType: BlockType.CODE,
                    template: `
const S${this.getSettingValue('SOCKET')}_TBT00_1 = ${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}`,
                });
            }
                break;
            case 'I2C':
                blocks.push({
                    location: 'boot',
                    blockType: BlockType.CODE,
                    template: `
    'Tibbit 00_1 on socket ${this.getSettingValue('SOCKET')} I2C setup 
    ${tibbitName}_CHANNEL=si2c_register("${tibbitName}",${tibbitName}_SDA,${tibbitName}_SCL,no)
    if ${tibbitName}_CHANNEL<4 then
        ssi.channel=${tibbitName}_CHANNEL
        ssi.enabled=NO
        ssi.baudrate=PL_SSI_BAUD_100kHz

        io.num=${tibbitName}_SDA
        io.state=HIGH

        io.num=${tibbitName}_SCL
        io.state=HIGH

        ssi.zmode = PL_SSI_ZMODE_ENABLED_ON_ZERO
        ssi.direction=PL_SSI_DIRECTION_LEFT
        ssi.domap = ${tibbitName}_SDA
        ssi.dimap = ${tibbitName}_SDA
        ssi.clkmap = ${tibbitName}_SCL
        ssi.mode = PL_SSI_MODE_0

        ssi.enabled=YES
    end if

    'example for I2C transaction:
    'ssi.channel=${tibbitName}_CHANNEL    
    'si2c_get(${tibbitName}_CHANNEL)
    'si2c_start()
    'si2c_write(&h01)
    'si2c_stop()`,
                });

                blocks.push({
                    location: 'GLOBAL_DIMS',
                    blockType: BlockType.CODE,
                    template:
                        `dim ${tibbitName}_CHANNEL as byte`,
                });

                blocks.push({
                    location: 'GLOBAL_DECLARATIONS',
                    blockType: BlockType.CODE,
                    template:
                        `declare ${tibbitName}_CHANNEL as byte`,
                });

                blocks.push({
                    location: 'GLOBAL_CONSTS',
                    blockType: BlockType.CODE,
                    template: `
const ${tibbitName}_SDA=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[this.getSettingValue('I2CSDA')]}
const ${tibbitName}_SCL=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[this.getSettingValue('I2CSCL')]}`,
                });
                break;
            case 'SPI':
                blocks.push({
                    location: 'boot',
                    blockType: BlockType.CODE,
                    template: `
    'SPI setup for ${tibbitName}
    ${tibbitName}_CHANNEL=sspi_register("${tibbitName}",${tibbitName}_DO,${tibbitName}_DI,${tibbitName}_CLK,SPI_MODE_${this.getSettingValue('CLOCKMODE')},yes)
    if(${tibbitName}_CHANNEL<4) {
        ssi.channel=${tibbitName}_CHANNEL;
        //SPI CLK
        io.num=${tibbitName}_CLK;
        io.state=HIGH;
        io.enabled=YES;                          //Enable as output
        //SPI DO (MOSI)
        io.num=${tibbitName}_DO
        io.state=HIGH;
        io.enabled=YES;
        //SPI DI (MISO)
        io.num=${tibbitName}_DI;
        io.enabled=NO;

        ssi.enabled=NO;
        ssi.mode=PL_SSI_MODE_${this.getSettingValue('CLOCKMODE')};
        ssi.direction=PL_SSI_DIRECTION_LEFT;
        ssi.clkmap=${tibbitName}_CLK;
        ssi.dimap=${tibbitName}_DI;
        ssi.domap=${tibbitName}_DO;
        ssi.zmode=PL_SSI_ZMODE_ALWAYS_ENABLED;
        ssi.baudrate=PL_SSI_BAUD_100kHz;
        ssi.enabled=YES;
        //chip select for SPI ${tibbitName};
        io.num=${tibbitName}_CS;
        io.enabled=YES;
    }
    
    //example for SPI transfer:
    //sspi_get(${tibbitName}_CHANNEL)
    //io.lineset(${tibbitName}_CS,LOW)
    //sspi_write(&h01)
    //io.lineset(${tibbitName}_CS,HIGH)`,
                });

                blocks.push({
                    location: 'GLOBAL_DIMS',
                    blockType: BlockType.CODE,
                    template:
                        `byte ${tibbitName}_CHANNEL;`,
                });

                blocks.push({
                    location: 'GLOBAL_DECLARATIONS',
                    blockType: BlockType.CODE,
                    template:
                        `extern byte ${tibbitName}_CHANNEL;`,
                });

                blocks.push({
                    location: 'GLOBAL_CONSTS',
                    blockType: BlockType.CODE,
                    template: `
const ${tibbitName}_CLK=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[this.getSettingValue('SPICLK')]}
const ${tibbitName}_DI=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[this.getSettingValue('SPIDI')]}
const ${tibbitName}_DO=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[this.getSettingValue('SPIDO')]}
const ${tibbitName}_CS=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[this.getSettingValue('SPICS')]}`,
                });
                break;
            default:
                {
                    const INTENABLED = (this.getSettingValue('INTENABLED') === '1') && (this.getState('INTENABLED') === SettingState.ENABLED);
                    let InterruptCode = '';
                    if (this.getSettingValue('L4DIRECTION') === '1') {
                        if (INTENABLED) {
                            InterruptCode = `io.intnum=S${this.getSettingValue('SOCKET')}_INT_NUM;
                                             io.intenabled=YES;`;
                        } else {
                            InterruptCode = `io.intnum=S${this.getSettingValue('SOCKET')}_INT_NUM;
                                             io.intenabled=NO;`;
                        }
                    }

                    const Tibbit00_1InitString = `'Tibbit 00_1 setup on socket ${this.getSettingValue('SOCKET')} for IO lines`;

                    for (let i = 1; i <= 4; i += 1) {
                        const LNAME = `L${i}NAME`;
                        const LDIRECTION = `L${i}DIRECTION`;
                        const LSTATE = `L${i}STATE`;
                        let LSTATECODE = '';
                        if (this.getSettingValue(LDIRECTION) === '0') {
                            LSTATECODE = this.getSettingValue(LSTATE) === '1' ? 'io.state=HIGH' : 'io.state=LOW';
                        }
                        blocks.push({
                            location: 'boot',
                            blockType: BlockType.CODE,
                            template: `
${i === 1 ? Tibbit00_1InitString : ''}
io.num=${this.getSettingValue(LNAME)}_num;
io.enabled=${this.getSettingValue(LDIRECTION) === '1' ? 'NO' : 'YES'};
${LSTATECODE}
${i === 4 ? InterruptCode : ''}
                `,
                        });
                        const VARNAME = this.getSettingValue(LNAME);
                        blocks.push({
                            location: `var_${VARNAME}_set`,
                            blockType: BlockType.CODE,
                            template: `io.lineset(${this.getSettingValue(LNAME)}_num, value)`,
                        });
                        blocks.push({
                            location: `var_${VARNAME}_update`,
                            blockType: BlockType.CODE,
                            template: `var_${VARNAME}_update_completed(io.lineget(${this.getSettingValue(LNAME)}_num))`,
                        });
                    }

                    const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
                    let interruptEnum = '';
                    if (interruptNumber) {
                        interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
                    }

                    blocks.push({
                        location: 'GLOBAL_CONSTS',
                        blockType: BlockType.CODE,
                        template: `
const ${this.getSettingValue('L1NAME')}_num = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[0]}
const ${this.getSettingValue('L2NAME')}_num = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[1]}
const ${this.getSettingValue('L3NAME')}_num = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
const ${this.getSettingValue('L4NAME')}_num = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[3]}
`,
                    });

                    blocks.push({
                        location: 'GLOBAL_CONSTS',
                        blockType: BlockType.CODE,
                        template: `const S${this.getSettingValue('SOCKET')}_INT_NUM = ${interruptEnum}`,
                    });
                    if (INTENABLED && interruptNumber) {
                        const interruptValue = PlatformUtils.getEnumValue(interruptNumber, 'pl_int_num', this.project.device.platform);
                        const interruptBit = Math.pow(2, Number(interruptValue));
                        blocks.push({
                            location: 'on_io_int',
                            blockType: BlockType.CODE,
                            template: `
    if (linestate and ${interruptBit}) <>0 then
        'interrupt has been triggered by the interrupt S${this.getSettingValue('SOCKET')}_INT_NUM
         
    end if
    `,
                        });
                    }
                }
                break;
        }

        return blocks;
    }
}
